"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_1 = require("mobx");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var Translate_1 = __importDefault(require("../../base/Translate"));

var Icon_1 = __importDefault(require("../../base/Icon"));

var DocumentTile_meta_1 = require("./DocumentTile.meta");

var DocumentTile =
/** @class */
function (_super) {
  __extends(DocumentTile, _super);

  function DocumentTile(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = DocumentTile_meta_1.DOCUMENT_TILE_CATEGORY_KEY;
    _this.componentKey = DocumentTile_meta_1.DOCUMENT_TILE_COMPONENT_KEY;
    _this.spinnerAssetKey = 'file.documentTile.spinner';
    _this.isDownloading = false;

    _this.handleClick = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, document, fileName, onClick;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, document = _a.document, fileName = _a.fileName, onClick = _a.onClick;
              if (!(document && onClick)) return [3
              /*break*/
              , 2];
              this.isDownloading = true;
              return [4
              /*yield*/
              , onClick(document, fileName)];

            case 1:
              _b.sent();

              this.isDownloading = false;
              _b.label = 2;

            case 2:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    return _this;
  }

  DocumentTile.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        label = _a.label,
        _b = _a.iconPosition,
        iconPosition = _b === void 0 ? 'before' : _b,
        iconProps = _a.iconProps,
        _c = _a.iconAssetKey,
        iconAssetKey = _c === void 0 ? 'file.documentTile.icon' : _c,
        _d = _a.useSpinner,
        useSpinner = _d === void 0 ? true : _d;
    var iconAsset = this.isDownloading && useSpinner ? this.spinnerAssetKey : iconAssetKey;
    var icon = react_1.default.createElement(Icon_1.default, __assign({}, iconProps, {
      asset: iconAsset
    }));
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      onClick: this.handleClick
    }, iconPosition === 'before' && icon, react_1.default.createElement(Label_1.default, null, react_1.default.createElement(Translate_1.default, null, label)), iconPosition === 'after' && icon);
  };

  __decorate([mobx_1.observable], DocumentTile.prototype, "isDownloading", void 0);

  DocumentTile = __decorate([mobx_react_1.observer], DocumentTile);
  return DocumentTile;
}(shared_1.ComponentBase);

exports.DocumentTile = DocumentTile;
exports.default = shared_1.InjectedStyledComponent(DocumentTile, DocumentTile_meta_1.DOCUMENT_TILE_CATEGORY_KEY, DocumentTile_meta_1.DOCUMENT_TILE_COMPONENT_KEY);